import apiClient from './client';

export const advertisersApi = {
  getAll(params = {}) {
    return apiClient.get('/advertisers', params);
  },

  getById(id, params = {}) {
    return apiClient.get(`/advertisers/${id}`, params);
  },

  create(data) {
    return apiClient.post('/advertisers', data);
  },

  update(id, data) {
    return apiClient.put(`/advertisers/${id}`, data);
  },

  delete(id) {
    return apiClient.delete(`/advertisers/${id}`);
  },
};

export default advertisersApi;
